import React from 'react';
import './ActivateWalletPrompt.css';
import { useTranslation } from 'react-i18next';

function ActivateWalletPrompt({ onClose, onActivate, threshold = 0.1 }) {
  const { t } = useTranslation();

  return (
    <div className="awp-backdrop" onClick={onClose}>
      <div
        className="awp-panel"
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
      >
        <div className="awp-grabber" />

        <h3 className="awp-title">
          {t('walletPrompt.title', 'Activate your Pi wallet')}
        </h3>

        <p className="awp-subtitle">
          {t(
            'walletPrompt.subtitle',
            'Did you know you can earn Pi from your posts and marketplace sales inside BarterFi?'
          )}
        </p>

        <ul className="awp-list">
          <li>
            {t(
              'walletPrompt.bullet1',
              'Top up at least {{amount}} Pi once to activate your wallet.',
              { amount: threshold }
            )}
          </li>
          <li>
            {t(
              'walletPrompt.bullet2',
              'Receive tips directly to your in-app wallet.'
            )}
          </li>
          <li>
            {t(
              'walletPrompt.bullet3',
              'Get paid in Pi for successful marketplace orders.'
            )}
          </li>
        </ul>

        {/* ACTION BUTTONS */}
        <div className="awp-actions">

          {/* 🔵 Activate FIRST (Left) */}
          <button className="awp-btn awp-btn-primary" onClick={onActivate}>
            {t('walletPrompt.activateNow', 'Activate wallet')}
          </button>

          {/* ⚪ Maybe later (Right) */}
          <button className="awp-btn awp-btn-secondary" onClick={onClose}>
            {t('walletPrompt.maybeLater', 'Maybe later')}
          </button>

        </div>

        <p className="awp-footer-hint">
          {t(
            'walletPrompt.footerHint',
            'You only need to activate once. After that, tips and payments can flow in automatically.'
          )}
        </p>
      </div>
    </div>
  );
}

export default ActivateWalletPrompt;
